import React from 'react';
import moment from 'moment';
import { isNullOrUndefined } from 'util';

export default class DateTimeLabel extends React.Component {
    constructor(args) {
        super(args);
        
        this.state = {
            format: this.getFormat(this.props)
        };
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            format: this.getFormat(newProps)
        });
    }

    getFormat(props) {
        let enableTime = isNullOrUndefined(props.enableTime) ? false : props.enableTime;
        return enableTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY";
    }

    render() {
        let value = this.props.value ? moment(this.props.value).format(this.state.format) : "";
        return (
            <div className={"input-group " + (this.props.className ? this.props.className : "")}>
                <input type="text"
                    className="form-control"
                    id={this.props.id}
                    title={this.props.title}
                    value={value}
                    disabled
                />
                <span className="input-group-addon">
                    <i className="fa fa-calendar"></i>
                </span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/controls/dateTimeLabel.jsx